module.exports = __webpack_public_path__ + "static/media/LandingTileBackground.6006b97b.png";